import { render, staticRenderFns } from "./NewRedeem.vue?vue&type=template&id=200142f4&scoped=true"
import script from "./NewRedeem.vue?vue&type=script&lang=js"
export * from "./NewRedeem.vue?vue&type=script&lang=js"
import style0 from "./NewRedeem.vue?vue&type=style&index=0&id=200142f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200142f4",
  null
  
)

export default component.exports